import React, { Component } from "react";
import PropTypes from "prop-types";
import Store from "../SessionStorage";
import { sessionStorageAction } from "../utils/index";
import { dispatchEventClickTag } from "../utils/Tags";
import "antd/dist/antd.less";
import {LogoAltimaIcon, LogoAltimaIconOverzoom} from "../../assets/icons";


export class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accessToken: null,
      menuMode: "horizontal",
    };
  }

  componentDidMount() {
    this.displayRetinaLogo = this.displayRetinaLogo.bind(this);
    this.displayClassicalLogo = this.displayClassicalLogo.bind(this);
    this.displayLogo = this.displayLogo(this);
  }

  static propTypes = {
    accessToken: PropTypes.string,
  };

  static defaultProps = {
    accessToken: null,
  };

  displayRetinaLogo = () => {
    if (window.innerWidth > 992){
      return  <LogoAltimaIcon className="logoAltima-retina" />
    } else {
      return <LogoAltimaIconOverzoom className="logoAltima-retina"/>
    }
  }

  displayClassicalLogo = () => {
    if (window.innerWidth > 992){
      return  <img alt="Logo Altima" src="https://rec.altima-assurances.fr/sites/default/files/logo/logo_altima_maif.png" className="logoAltima"/>
    } else {
      return <img alt="Logo Altima" src="https://rec.altima-assurances.fr/sites/default/files/logo/logo_altima_maif_overzoom.png" className="logoAltima"/>
    }
  }

  displayLogo = () => {
    if(window.devicePixelRatio > 1){
      return this.displayRetinaLogo()
    }else{
      return this.displayClassicalLogo()
    }
  }

  componentDidMount() {
    if (this.props.accessToken) {
      this.setState({ accessToken: this.props.accessToken });
    } else if (Store.get(sessionStorageAction.dashboard.accessToken)) {
      this.setState({
        accessToken: Store.get(sessionStorageAction.dashboard.accessToken),
      });
    }
  }

  render() {
    return (
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div className="container-header-logo">
          <a
            href="/"
            onClick={() =>
              dispatchEventClickTag("logo", "menu", "", "navigation")
            }
            title="Logo Altima Assurance"
          >
            {
              this.displayLogo()
            }
          </a>
        </div>
      </div>
    );
  }
}
